import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'app-datepicker',
    templateUrl: './customdatepicker.component.html'
})
export class CustomdatepickerComponent implements OnInit {
    @Input() data;
    today;
    year;
    month;
    day;

    ngOnInit() {
        const _date = new Date();
        this.today = {
            year: _date.getFullYear(),
            month: _date.getMonth() + 1,
            day: _date.getDate()
        };
    }

    isToday(_date) {
        return _date.year === this.today.year && _date.month === this.today.month && _date.day === this.today.day;
    }
}
